<div class="sidebar-menu">
    <div class="flex items-center space-x-2">
      <img
        (click)="goToDashboard()"
        src="/assets/images/logo.svg"
        width="200"
      />
    </div>
    <app-sidebar></app-sidebar>
</div>
